import { render, staticRenderFns } from "./BaseFrontOfficeButton.vue?vue&type=template&id=366dcaba&scoped=true"
import script from "./BaseFrontOfficeButton.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeButton.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeButton.vue?vue&type=style&index=0&id=366dcaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366dcaba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
